import { Component, ChangeDetectionStrategy } from '@angular/core';
import {Store} from '@softline/core';
import {RouterModule} from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterModule]
})
export class AppComponent {
  constructor(public store: Store) {}
}
